import React from 'react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import Select from '@/components/UI/Select'

import { InputSelect } from '../styled'
import { FormContext, type FormInputType } from '../types'

const FormInputSelect: React.FC<{
  input: FormInputType & { type: 'select' | 'select-group' }
}> = ({ input }) => {
  const { name: inputName, onChange: inputOnChange, isLoading = false, required = false } = input
  const { submitting, onChange } = React.useContext(FormContext)
  const handleChange = React.useCallback(
    (value?: string) => {
      onChange(inputName, value ?? '')
      inputOnChange?.(value ?? '')
    },
    [inputName, inputOnChange, onChange]
  )

  const flattenedOptions =
    input.type === 'select-group' ? input.options.flatMap(o => o.options) : input.options
  return (
    <InputSelect>
      <Select
        instanceId={input.name}
        name={input.name}
        options={input.options}
        placeholder={input.placeholder}
        isLoading={isLoading}
        defaultValue={flattenedOptions.find(option => option.value === input.initialValue)}
        onChange={e => handleChange(e?.value)}
        isDisabled={submitting || input.disabled}
        isSearchable
        isClearable={required === false}
        styles={{
          control: base => ({
            ...base,
            borderColor: `${chakraTokenToVar('border')}`,
          }),
        }}
      />
    </InputSelect>
  )
}

export default FormInputSelect
